module.exports = __webpack_public_path__ + "static/Patient-Visit-Experiences-124c2e7916ef60e09bb09e65e2c78fe9.jpg";